import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../Components/Layout';
import SweepstakeDetails from '../Components/SweepstakeDetails';
import isBrowser from '../utils/isBrowser';

const PromotionDetailsPage = ({ user, config, cmsSourceFirebase, actions, match, sweep }) => {
    useEffect(() => {
        actions.sweepActions.getSweeps();
    }, [actions]);

    //* Retrieve ID from url params

    const queryString = isBrowser() ? window.location.search : '';
    const urlParams = new URLSearchParams(queryString);

    const preselection = {
        sweepId: parseInt(urlParams.get('id')),
    };
    const sweeps = sweep?.sweeps;
    let selectedSweep = null;
    if (sweeps && Array.isArray(sweeps)) {
        selectedSweep = sweeps?.filter((s) => s.id === preselection.sweepId)?.[0];
    }
    return (
        <Layout
            {...{
                user,
                config,
                cmsSourceFirebase,
                actions,
                match,
                configReplacements: [
                    {
                        find: '{{PROMOTION_NAME}}',
                        replace: selectedSweep?.name ?? '',
                    },
                ],
            }}>
            <SweepstakeDetails selectedSweep={selectedSweep} />
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(PromotionDetailsPage);
